import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import NotFound from '../pages/NotFound';
import { Navigate } from 'react-router-dom';

// Lazy loading des composants
const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Boutique = lazy(() => import('../pages/boutique/page'));
const Catalogue = lazy(() => import('../pages/catalogue/page'));
const Panier = lazy(() => import('../pages/panier/page'));
const Merci = lazy(() => import('../pages/merci/page'));
const PaiementAnnule = lazy(() => import('../pages/paiement-annule/page'));
const MerciCommande = lazy(() => import('../pages/merci-commande/page'));
const Noel = lazy(() => import('../pages/noel/page'));
const Personnalisations = lazy(() => import('../pages/personnalisations/page'));
const Livraison = lazy(() => import('../pages/livraison/page'));
const PaiementSecurise = lazy(() => import('../pages/paiement-securise/page'));
const MentionsLegales = lazy(() => import('../pages/mentions-legales/page'));
const AdminImages = lazy(() => import('../pages/admin-images/page'));
const AdminVentes = lazy(() => import('../pages/admin-ventes/page'));
const AdminStocks = lazy(() => import('../pages/admin-stocks/page'));
const OffresAPrixDoux = lazy(() => import('../pages/offres-a-prix-doux/page'));
const AvantPremiere = lazy(() => import('../pages/vip-48h-210126/page'));

// Pages produits
const ProduitAngeAPoser25cm = lazy(() => import('../pages/produit-ange-a-poser-25cm/page'));
const ProduitAngeJoyeuxCoeur = lazy(() => import('../pages/produit-ange-joyeux-coeur/page'));
const ProduitAngeReveDoux = lazy(() => import('../pages/produit-ange-reve-doux/page'));
const ProduitAngeSerenite = lazy(() => import('../pages/produit-ange-serenite/page'));
const ProduitAngeAPoserModele1 = lazy(() => import('../pages/produit-ange-a-poser-modele-1/page'));
const ProduitAngeAPoserModele2 = lazy(() => import('../pages/produit-ange-a-poser-modele-2/page'));
const ProduitAngeAPoserModele3 = lazy(() => import('../pages/produit-ange-a-poser-modele-3/page'));
const ProduitBougieLivrePlie = lazy(() => import('../pages/produit-bougie-livre-plie/page'));
const ProduitBougieLivrePlieAvecLed = lazy(() => import('../pages/produit-bougie-livre-plie-avec-led/page'));
const ProduitBougieLivrePlieAvecLedV2 = lazy(() => import('../pages/produit-bougie-livre-plie-avec-led-v2/page'));
const ProduitBougieLivrePlieSansLed = lazy(() => import('../pages/produit-bougie-livre-plie-sans-led/page'));
const ProduitBougieLivrePlieSansLedV2 = lazy(() => import('../pages/produit-bougie-livre-plie-sans-led-v2/page'));
const ProduitBouleNoelArgentPailletee = lazy(() => import('../pages/produit-boule-noel-argent-pailletee/page'));
const ProduitBouleNoelPagesLivre = lazy(() => import('../pages/produit-boule-noel-pages-livre/page'));
const ProduitBouleNoelLivresPliesBleu = lazy(() => import('../pages/produit-boule-noel-livres-plies-bleu/page'));
const ProduitLot2SapinsNoelLivrePlie = lazy(() => import('../pages/produit-lot-2-sapins-noel-livre-plie/page'));
const ProduitLot3AngesJoyeuxCoeur = lazy(() => import('../pages/produit-lot-3-anges-joyeux-coeur/page'));
const ProduitLot3AngesMixte = lazy(() => import('../pages/produit-lot-3-anges-mixte/page'));
const ProduitLot3AngesReveDoux = lazy(() => import('../pages/produit-lot-3-anges-reve-doux/page'));
const ProduitLot3AngesSerenite = lazy(() => import('../pages/produit-lot-3-anges-serenite/page'));
const ProduitSapinNoelLivrePlie = lazy(() => import('../pages/produit-sapin-noel-livre-plie/page'));
const ProduitSapinsNoelLivrePliePiecesUniques = lazy(() => import('../pages/produit-sapins-noel-livre-plie-pieces-uniques/page'));
const ProduitBonhommeNeigeLivrePlie = lazy(() => import('../pages/produit-bonhomme-neige-livre-plie/page'));
const ProduitBonhommeNeigeLumineux = lazy(() => import('../pages/produit-bonhomme-neige-lumineux/page'));
const ProduitBouleNoelPapierRougeNaturel = lazy(() => import('../pages/produit-boule-noel-papier-rouge-naturel/page'));
const ProduitBouleNoelPapierBleuPoisDores = lazy(() => import('../pages/produit-boule-noel-papier-bleu-pois-dores/page'));
const ProduitBouleNoelPapierGrisArgent = lazy(() => import('../pages/produit-boule-noel-papier-gris-argent/page'));
const ProduitCageOiseauxOiseauFleurs = lazy(() => import('../pages/produit-cage-oiseaux-oiseau-fleurs/page'));
const ProduitCageOiseauxTrioOiseauxFleurRouge = lazy(() => import('../pages/produit-cage-oiseaux-trio-oiseaux-fleur-rouge/page'));
const ProduitAngeOrLumiere = lazy(() => import('../pages/produit-ange-or-lumiere/page'));
const ProduitChandelierLivrePlieDentellePerles = lazy(() => import('../pages/produit-chandelier-livre-plie-dentelle-perles/page'));
const ProduitChandelierLivrePlieBlancPerles = lazy(() => import('../pages/produit-chandelier-livre-plie-blanc-perles/page'));
const ProduitSapinOrLumieres = lazy(() => import('../pages/produit-sapin-or-lumieres/page'));
const ProduitSapinFlammeDoreeLumieres = lazy(() => import('../pages/produit-sapin-flamme-doree-lumieres/page'));
const ProduitDecorationMuraleFeuillageOrnementsNoel = lazy(() => import('../pages/produit-decoration-murale-feuillage-ornements-noel/page'));
const PourquoiOffrirPage = lazy(() => import('../pages/pourquoi-offrir/page'));
const ProduitDeuxCoeursUneHistoire = lazy(() => import('../pages/produit-deux-coeurs-une-histoire/page'));
const ProduitJesusPortraitLivrePlie = lazy(() => import('../pages/produit-jesus-portrait-livre-plie/page'));
const ProduitCoeurBlancLivrePlie = lazy(() => import('../pages/produit-coeur-blanc-livre-plie/page'));
const ProduitLoveLivrePlie = lazy(() => import('../pages/produit-love-livre-plie/page'));
const ProduitQuatreCoeursLivrePlie = lazy(() => import('../pages/produit-quatre-coeurs-livre-plie/page'));
const ProduitCoeurRubanRougeLivrePlie = lazy(() => import('../pages/produit-coeur-ruban-rouge-livre-plie/page'));
const ProduitLapinLivrePlie = lazy(() => import('../pages/produit-lapin-livre-plie/page'));
const ProduitOeufPaquesLivrePlie = lazy(() => import('../pages/produit-oeuf-paques-livre-plie/page'));
const ProduitHerissonPorteLettresLivrePlie = lazy(() => import('../pages/produit-herisson-porte-lettres-livre-plie/page'));
const ProduitBouquetEternelLivrePlie = lazy(() => import('../pages/produit-bouquet-eternel-livre-plie/page'));
const ProduitBelierLivrePlie = lazy(() => import('../pages/produit-belier-livre-plie/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/boutique',
    element: <Boutique />,
  },
  {
    path: '/catalogue',
    element: <Catalogue />,
  },
  {
    path: '/panier',
    element: <Panier />,
  },
  {
    path: '/merci',
    element: <Merci />,
  },
  {
    path: '/paiement-annule',
    element: <PaiementAnnule />,
  },
  {
    path: '/merci-commande',
    element: <MerciCommande />,
  },
  {
    path: '/noel',
    element: <Noel />,
  },
  {
    path: '/personnalisations',
    element: <Personnalisations />,
  },
  {
    path: '/livraison',
    element: <Livraison />,
  },
  {
    path: '/paiement-securise',
    element: <PaiementSecurise />,
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegales />,
  },
  {
    path: '/admin-images',
    element: <AdminImages />,
  },
  {
    path: '/admin-ventes',
    element: <AdminVentes />
  },
  {
    path: '/admin-stocks',
    element: <AdminStocks />,
  },
  {
    path: '/offres-a-prix-doux',
    element: <OffresAPrixDoux />,
  },
  {
    path: '/vip-48h-210126',
    element: <AvantPremiere />,
  },
  // Redirection 301 de l'ancienne URL vers la nouvelle
  {
    path: '/avant-premiere',
    element: <Navigate to="/vip-48h-210126" replace />,
  },
  // Pages produits
  {
    path: '/produit-ange-a-poser-25cm',
    element: <ProduitAngeAPoser25cm />,
  },
  {
    path: '/produit-ange-joyeux-coeur',
    element: <ProduitAngeJoyeuxCoeur />,
  },
  {
    path: '/produit-ange-reve-doux',
    element: <ProduitAngeReveDoux />,
  },
  {
    path: '/produit-ange-serenite',
    element: <ProduitAngeSerenite />,
  },
  {
    path: '/produit-ange-a-poser-modele-1',
    element: <ProduitAngeAPoserModele1 />,
  },
  {
    path: '/produit-ange-a-poser-modele-2',
    element: <ProduitAngeAPoserModele2 />,
  },
  {
    path: '/produit-ange-a-poser-modele-3',
    element: <ProduitAngeAPoserModele3 />,
  },
  {
    path: '/produit-bougie-livre-plie',
    element: <ProduitBougieLivrePlie />,
  },
  {
    path: '/produit-bougie-livre-plie-avec-led',
    element: <ProduitBougieLivrePlieAvecLed />,
  },
  {
    path: '/produit-bougie-livre-plie-avec-led-v2',
    element: <ProduitBougieLivrePlieAvecLedV2 />,
  },
  {
    path: '/produit-bougie-livre-plie-sans-led',
    element: <ProduitBougieLivrePlieSansLed />,
  },
  {
    path: '/produit-bougie-livre-plie-sans-led-v2',
    element: <ProduitBougieLivrePlieSansLedV2 />,
  },
  {
    path: '/produit-boule-noel-argent-pailletee',
    element: <ProduitBouleNoelArgentPailletee />
  },
  {
    path: '/produit-boule-noel-pages-livre',
    element: <ProduitBouleNoelPagesLivre />
  },
  {
    path: '/produit-boule-noel-livres-plies-bleu',
    element: <ProduitBouleNoelLivresPliesBleu />
  },
  {
    path: '/produit-lot-2-sapins-noel-livre-plie',
    element: <ProduitLot2SapinsNoelLivrePlie />,
  },
  {
    path: '/produit-lot-3-anges-joyeux-coeur',
    element: <ProduitLot3AngesJoyeuxCoeur />,
  },
  {
    path: '/produit-lot-3-anges-mixte',
    element: <ProduitLot3AngesMixte />,
  },
  {
    path: '/produit-lot-3-anges-reve-doux',
    element: <ProduitLot3AngesReveDoux />,
  },
  {
    path: '/produit-lot-3-anges-serenite',
    element: <ProduitLot3AngesSerenite />,
  },
  {
    path: '/produit-sapin-noel-livre-plie',
    element: <ProduitSapinNoelLivrePlie />,
  },
  {
    path: '/produit-sapins-noel-livre-plie-pieces-uniques',
    element: <ProduitSapinsNoelLivrePliePiecesUniques />,
  },
  {
    path: '/produit-bonhomme-neige-livre-plie',
    element: <ProduitBonhommeNeigeLivrePlie />,
  },
  {
    path: '/produit-bonhomme-neige-lumineux',
    element: <ProduitBonhommeNeigeLumineux />,
  },
  {
    path: '/produit-boule-noel-papier-rouge-naturel',
    element: <ProduitBouleNoelPapierRougeNaturel />,
  },
  {
    path: '/produit-boule-noel-papier-bleu-pois-dores',
    element: <ProduitBouleNoelPapierBleuPoisDores />,
  },
  {
    path: '/produit-boule-noel-papier-gris-argent',
    element: <ProduitBouleNoelPapierGrisArgent />,
  },
  {
    path: '/produit-cage-oiseaux-oiseau-fleurs',
    element: <ProduitCageOiseauxOiseauFleurs />,
  },
  {
    path: '/produit-cage-oiseaux-trio-oiseaux-fleur-rouge',
    element: <ProduitCageOiseauxTrioOiseauxFleurRouge />,
  },
  {
    path: '/produit-ange-or-lumiere',
    element: <ProduitAngeOrLumiere />,
  },
  {
    path: '/produit-chandelier-livre-plie-dentelle-perles',
    element: <ProduitChandelierLivrePlieDentellePerles />,
  },
  {
    path: '/produit-chandelier-livre-plie-blanc-perles',
    element: <ProduitChandelierLivrePlieBlancPerles />,
  },
  {
    path: '/produit-sapin-or-lumieres',
    element: <ProduitSapinOrLumieres />,
  },
  {
    path: '/produit-sapin-flamme-doree-lumieres',
    element: <ProduitSapinFlammeDoreeLumieres />,
  },
  {
    path: '/produit-decoration-murale-feuillage-ornements-noel',
    element: <ProduitDecorationMuraleFeuillageOrnementsNoel />,
  },
  {
    path: '/pourquoi-offrir',
    element: <PourquoiOffrirPage />,
  },
  {
    path: '/produit-deux-coeurs-une-histoire',
    element: <ProduitDeuxCoeursUneHistoire />,
  },
  {
    path: '/produit-jesus-portrait-livre-plie',
    element: <ProduitJesusPortraitLivrePlie />,
  },
  {
    path: '/produit-coeur-blanc-livre-plie',
    element: <ProduitCoeurBlancLivrePlie />,
  },
  {
    path: '/produit-love-livre-plie',
    element: <ProduitLoveLivrePlie />
  },
  {
    path: '/produit-quatre-coeurs-livre-plie',
    element: <ProduitQuatreCoeursLivrePlie />
  },
  {
    path: '/produit-coeur-ruban-rouge-livre-plie',
    element: <ProduitCoeurRubanRougeLivrePlie />
  },
  {
    path: '/produit-lapin-livre-plie',
    element: <ProduitLapinLivrePlie />,
  },
  {
    path: '/produit-oeuf-paques-livre-plie',
    element: <ProduitOeufPaquesLivrePlie />,
  },
  {
    path: '/produit-herisson-porte-lettres-livre-plie',
    element: <ProduitHerissonPorteLettresLivrePlie />,
  },
  {
    path: '/produit-bouquet-eternel-livre-plie',
    element: <ProduitBouquetEternelLivrePlie />,
  },
  {
    path: '/produit-belier-livre-plie',
    element: <ProduitBelierLivrePlie />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;